import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  setBaseApi(url: string, environment?: any) {
    console.log('task service apibase:' + url );
    SERVICE_CONFIG.baseApi = url;
    if (environment) {
      SERVICE_CONFIG.environment = environment;
    }
  }

  constructor(private httpClient: HttpClient) {}

  getPrefix(): string {
    if (SERVICE_CONFIG.baseApi) {
      return SERVICE_CONFIG.baseApi;
    } else {
      const links = localStorage.getItem('links');
      if (links) {
        try {
          const link = JSON.parse(links);
          return link.base.href;
        } catch (e) {
          console.log('从缓存获取links失败', e);
          return '';
        }
      } else {
        return '';
      }
    }
  }

  // 获取用户面板列表
  getUserBoardData(): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards';
    return this.httpClient.get(url);
  }
  // 创建面板
  doCreateBoard(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards';
    return this.httpClient.post(url, param);
  }
  // 删除归档面板
  doDeleteBoard(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId;
    return this.httpClient.delete(url, {params: param});
  }
  updateBoard(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId;
    return this.httpClient.patch(url, {}, {params: param});
  }
  updateBoardViews(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/board_definition/' + boardId;
    return this.httpClient.patch(url, param);
  }
  // 获取模板列表
  getBoardTemplateData(): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_templates';
    return this.httpClient.get(url);
  }
  // 获取面板数据
  getBoardData(boardId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId;
    return this.httpClient.get(url);
  }
  // 按日期查询面板数据
  queryDateTaskPanel(boardId, params) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId;
    return this.httpClient.get(url, {params: params});
  }
  // 新增分组
  doAddGroup(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/groups';
    return this.httpClient.post(url, param);
  }
  // 获取面板列
  getBoardColumn(boardId) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/get_columns';
    return this.httpClient.get(url, {});
  }
  // 添加行
  doAddPulse(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects';
    return this.httpClient.post(url, param);
  }
  // 添加列
  doAddColumn(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns';
    return this.httpClient.post(url, param);
  }
  // 删除分组
  doDeleteGroup(boardId, groupId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/groups/' + groupId;
    return this.httpClient.delete(url, {params: param});
  }
  // 删除列
  doDeleteColumn(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId;
    return this.httpClient.delete(url, {params: param});
  }
  // 删除行
  doDeletePulse(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/batch_delete_or_archive';
    return this.httpClient.post(url, param);
  }
  // 编辑组名
  doEditGroupTitle(boardId, GroupId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/groups/' + GroupId;
    return this.httpClient.patch(url, param);
  }
  // 修改分组标签
  doEditGroupLabel(boardId, GroupId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/groups/' + GroupId;
    return this.httpClient.patch(url, param);
  }
  // 编辑表头
  doEditColumnHeader(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId;
    return this.httpClient.patch(url, param);
  }
  // 编辑行NAME
  doEditPulseName(pulseId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId;
    return this.httpClient.patch(url, param);
  }
  // 编辑单元格
  doEditPulse(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/batch_change_column_value';
    return this.httpClient.post(url, param);
  }
  // 新增状态label
  doAddStatusLabel(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId;
    return this.httpClient.patch(url, param);
  }
  // 新增评论
  addPosts(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_pulse_posts';
    return this.httpClient.post(url, param);
  }
  // 获取评论列表
  getPosts(pulseId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_pulse_posts/pulses/' + pulseId;
    return this.httpClient.get(url, {params: param});
  }
  // 回复评论
  doReplayPost(postId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_pulse_posts/' + postId + '/reply';
    return this.httpClient.post(url, param);
  }
  // 删除评论
  doRemovePost(postId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_pulse_posts/' + postId;
    return this.httpClient.delete(url);
  }
  // 获取日志列表
  getLogData(pulseId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_change_logs/pulses/' + pulseId;
    return this.httpClient.get(url, {params: param});
  }
  // 获取工具箱列表
  getInfoBoxData(pulseId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId + '/collaboration_boxes';
    return this.httpClient.get(url, {params: param});
  }
  // 新增资料箱
  addInfoBox(pulseId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId + '/collaboration_boxes';
    return this.httpClient.post(url, param);
  }
  // 修改资料箱
  editInfoBox(pulseId, id, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId + '/collaboration_boxes/' + id;
    return this.httpClient.patch(url, param);
  }
  // 删除资料箱
  deleteInfoBox(pulseId, id): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId + '/collaboration_boxes/' + id;
    return this.httpClient.delete(url);
  }
  // 归档项列表
  getRecycleData(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_recycle_bins/get_log_entries';
    return this.httpClient.get(url, {params: param});
  }
  // 归档项列表
  queryGroupRecycleWithLabel(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_recycle_bins/get_group_recycle_with_label';
    return this.httpClient.get(url, {params: param});
  }
  // 回复归档
  restoreRecycle(recycleBinId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_recycle_bins/' + recycleBinId + '/restore';
    return this.httpClient.post(url, {});
  }
  // 恢复归档
  restoreRecycleNew(type, objectId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_recycle_bins/' + type + '/' + objectId + '/restore';
    return this.httpClient.post(url, {});
  }
  // 查看归档行数据
  getPulseData(pulseId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId + '/fetch_pulse';
    return this.httpClient.get(url);
  }
  getGroupData(boardId, groupId, param?: any) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/get_group_data/' + groupId;
    return this.httpClient.get(url, {params: param});
  }
  // 分组折叠
  setCollapseState(boardId, groupId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/groups/' + groupId + '/set_collapse_state';
    return this.httpClient.post(url, param);
  }
  // 折叠所有
  setAllCollapseState(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/groups/set_collapse_state';
    return this.httpClient.post(url, param);
  }
  // 批量更新
  batchChangeColumn(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/batch_change_column_values';
    return this.httpClient.post(url, param);
  }
  columnSort(groupId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/columns' + '/' + groupId + '/sort';
    return this.httpClient.patch(url, param);
  }
  // 获取自动化列表数据
  getIntegrationData(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/recipes';
    // const url = 'https://easy-mock.91asl.com:9443/mock/5df3332d06e8b100206738b9/example/integrations2';
    return this.httpClient.get(url, {params: param});
  }
  // 列数据绑定映射
  getAutomationsBoundTypeMap(param, externalParam?): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/' + param.relationId + '/boards/' + param.boardId + '/columns/' + param.columnId + '/bound_type_map';
    if (externalParam && JSON.stringify(externalParam) !== '{}') {
      return this.httpClient.get(url, {params: externalParam});
    } else {
      return this.httpClient.get(url);
    }
  }
  // 新增自动化实例
  addAutomations(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/automations';
    return this.httpClient.post(url, param);
  }
  // 获取自动化实例列表
  getAutomations(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/automations_page';
    // const url = 'https://easy-mock.91asl.com:9443/mock/5df3332d06e8b100206738b9/example/integrations';
    return this.httpClient.get(url, {params: param});
  }
  // 获取带分页自动化实例列表
  getAutomationPages(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/automations_page';
    return this.httpClient.get(url, {params: param});
  }
  // 打开/关闭自动化实例
  switchAutomations(instanceId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/automations/' + instanceId;
    return this.httpClient.patch(url, param);
  }
  // 修改自动化实例
  patchAutomations(instanceId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/automations/' + instanceId;
    return this.httpClient.patch(url, param);
  }
  // 删除自动化实例
  deleteAutomations(instanceId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/automations/' + instanceId;
    return this.httpClient.delete(url);
  }
  // 按钮组件触发事件
  buttonClickEvent(path, param, isExternalUrl?): Observable<any> {
    let url =  SERVICE_CONFIG.baseApi + path;
    if (isExternalUrl) {
      url = path;
    }
    return this.httpClient.post(url, param);
  }
  // 查询待选用户列表
  getBoardUser(boardId) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/users';
    return url;
  }

  getBoardUer(boardId, params) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/users';
    return this.httpClient.get(url, {params: params});
  }
  // 查询面板订阅人列表
  getBoardSubscribers(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/subscribers';
    return this.httpClient.get(url, {params: param});
  }
  // 新增面板订阅人
  addBoardSubscriber(boardId, param): Observable<any> {
    const url =  SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/subscribers';
    return this.httpClient.post(url, param);
  }
  // 修改面板订阅人
  editBoardSubscriber(boardId, subscriberId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/subscribers/' + subscriberId;
    return this.httpClient.patch(url, param);
  }
  // 删除面板订阅人
  removeBoardSubscriber(boardId, subscriberId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/subscribers/' + subscriberId;
    return this.httpClient.delete(url);
  }
  // 查询面板权限
  getBoardPermission(boardId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/get_permission';
    return this.httpClient.get(url);
  }
  // 新增面板权限
  addBoardPermission(boardId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/set_permission';
    return this.httpClient.post(url, param);
  }
  // 列锁定
  setLockState(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId + '/set_lock_state';
    return this.httpClient.post(url, param);
  }
  // 列隐藏
  setHideState(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId + '/set_hide_state';
    return this.httpClient.post(url, param);
  }
  // 查询列中已选用户
  getColumnUsers(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId + '/users';
    return this.httpClient.get(url, {params: param});
  }
  // 增加列权限
  addPermit(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId + '/add_permit';
    return this.httpClient.post(url, param);
  }
  // 移除列权限
  removePermit(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId + '/remove_permit';
    return this.httpClient.post(url, param);
  }
  // 查询列中已选用户
  getColumnsUser(boardId, pulseId, columnId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/pulses/' + pulseId + '/columns/' + columnId + '/users';
    return this.httpClient.get(url);
  }
  // 设置列加密权限
  setColumnEncrypt(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId + '/set_encrypt';
    return this.httpClient.post(url, param);
  }
  // 面板数据查询
  queryTaskPanel(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId;
    return this.httpClient.get(url, {params: param});
  }
  // 延期接口
  delayTask(pulseId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + pulseId;
    return this.httpClient.patch(url, param);
  }
  // 导出面板数据到Excel
  exportBoardToExcel(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/export_excel/' + boardId;
    return this.httpClient.post(url, param, {responseType: 'blob'});
  }
  // 导出面板数据到Excel
  exportExcelWithInfoBox(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/export_excel_with_info_box/' + boardId;
    return this.httpClient.post(url, param, {responseType: 'blob'});
  }
  // 导入excel数据到面板
  importExcelToBoard(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/create_board_from_matrix';
    return this.httpClient.post(url, param);
  }
  // 新增下拉选项
  doAddSelectOption(boardId, columnId, param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/columns/' + columnId;
    return this.httpClient.patch(url, param);
  }

  // 查询短信模板列表
  querySmsTemplateList() {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_notification_configs/list';
    return this.httpClient.get(url, {});
  }

  batchDownload(ids) {
    const url = SERVICE_CONFIG.baseApi + '/v1/files/downloads';
    return this.httpClient.post(url, ids, {responseType: 'blob'});
  }

  batchDownloadWithWatermark(params) {
    const url = SERVICE_CONFIG.baseApi + '/v1/files/download_with_watermark';
    return this.httpClient.post(url, params, {responseType: 'blob'});
  }

  /**
   * 以日期为维度，统计面板下各分组的任务
   * @param boardId 面板id
   * @param dateColumnId 日期列id
   * @param personColumnId 人员列id
   * @param statusColumnId 状态列id
   */
  statisticsDashboard(boardId: string, dateColumnId: string, personColumnId: string, statusColumnId: string) {
    const param = {};
    if (boardId) param['boardId'] = boardId;
    if (dateColumnId) param['dateColumnId'] = dateColumnId;
    if (personColumnId) param['personColumnId'] = personColumnId;
    if (statusColumnId) param['statusColumnId'] = statusColumnId;
    const url = SERVICE_CONFIG.baseApi + '/v1/statistics/dashboard';
    return this.httpClient.get(url, param);
  }

  /**
   * 统计过去30天每天任务数量
   */
  statisticsLast30daysTask() {
    const url = SERVICE_CONFIG.baseApi + '/v1/statistics/last_30_days_task';
    return this.httpClient.get(url, {});
  }

  /**
   * 统计未来一周每天任务数量
   */
  statisticsFutureWeekTask() {
    const url = SERVICE_CONFIG.baseApi + '/v1/statistics/future_week_task';
    return this.httpClient.get(url, {});
  }

  // 全局搜索
  searchEverything(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/query';
    return this.httpClient.get(url, {params: param});
  }

  moveToGroup(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/move_to_group';
    return this.httpClient.post(url, param);
  }

  importDataToGroup(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/import_data_to_group';
    return this.httpClient.post(url, param);
  }

  // 获取分组权限设置
  getGroupAuthority(boardId, groupId) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/get_group_authority/' + groupId;
    return this.httpClient.get(url, {});
  }

  // 设置分组权限
  setGroupAuthority(boardId, groupId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/set_group_authority/' + groupId;
    return this.httpClient.post(url, param);
  }

  // 设置表头锁定
  setTitleLock(boardId, titleLock) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/set_title_lock';
    return this.httpClient.post(url, {}, {params: {titleLock: titleLock}});
  }

  // 获取面板行
  getBoardPulses(boardId) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/pulses';
    return this.httpClient.get(url, {});
  }

  batchAttachUser(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/batch_attach_user';
    return this.httpClient.post(url, param);
  }

  getBoardGroups(boardId) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/get_groups';
    return this.httpClient.get(url, {});
  }

  // 交换分组位置
  changeGroupPos(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/change_group_position';
    return this.httpClient.post(url, param);
  }
  // 调整列位置
  changeColumnPos(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/change_column_position';
    return this.httpClient.post(url, param);
  }
  // 查询流程列表
  queryProcessList(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/query_process_list';
    return this.httpClient.get(url, {params: param});
  }
  // 根据流程id查询流程节点
  queryProcessActivities(id, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/query_process_activities/' + id;
    return this.httpClient.get(url, {params: param});
  }

  queryAuditBoardList(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/query_audit_board_list';
    return this.httpClient.get(url, {params: param});
  }

  queryAuditItemList(id, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/automations/query_audit_item_list/' + id;
    return this.httpClient.get(url, {params: param});
  }

  getBoardCategoryList(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_category/list';
    return this.httpClient.get(url, {params: param});
  }
  getBoardNameList(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/get_board_info';
    return this.httpClient.get(url, {params: param});
  }
  updateBoardSort(boardId, param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/boards/' + boardId + '/update_sort';
    return this.httpClient.patch(url, param);
  }
  // 新增分类
  createBoardCategory(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_category';
    return this.httpClient.post(url, param);
  }
  // 编辑分类
  editBoardCategory(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_category';
    return this.httpClient.patch(url, param);
  }
  // 删除分类
  removeBoardCategory(id) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_category/' + id;
    return this.httpClient.delete(url);
  }
  // 置状态请求查询接口
  queryStatus(url, param): Observable<any> {
    return this.httpClient.get(url, {params: param});
  }
  // 行排序
  pulseSort(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/pulse_sort';
    return this.httpClient.post(url, param);
  }
  pulsePostReadRecord(boardId, pulseId, count) {
    const url = SERVICE_CONFIG.baseApi + '/v1/projects/' + boardId + '/' + pulseId + '/pulse_post_read_record';
    return this.httpClient.post(url, {}, {params: {count: count}});
  }
  // 获取任务池任务列表
  getManualTaskData(boardId) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    // const url = operationBaseApi + '/v1/task_defs_new';
    const url = operationBaseApi + '/v1/task_defs_new/manual_task_def/' + boardId;
    return this.httpClient.get(url);
  }
  // 任务部门
  getTaskDepartment() {
    const systemBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('systemModule') && SERVICE_CONFIG.environment['systemModule'] ? SERVICE_CONFIG.environment['systemModule']  : '';
    const url = systemBaseApi + '/v1/operation_orgs';
    // const url = 'http://gs-ms.91asl.cn:7800/system/v1/operation_orgs';
    return this.httpClient.get(url);
  }
  // 班次查询
  getWorkDefs(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/work_defs';
    // const url = 'http://gs-ms.91asl.cn:7800/operation/v1/work_defs';
    return this.httpClient.get(url, { params});
  }
  // 获取公钥
  getPublicKey(): Observable<any> {
    const systemBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('systemModule') && SERVICE_CONFIG.environment['systemModule'] ? SERVICE_CONFIG.environment['systemModule']  : '';
    const url = systemBaseApi + '/v1/get_public_key';
    return this.httpClient.get(url);
  }
  login(param): Observable<any> {
    const systemBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('systemModule') && SERVICE_CONFIG.environment['systemModule'] ? SERVICE_CONFIG.environment['systemModule']  : '';
    const url = systemBaseApi + '/auth/auth_user';
    return this.httpClient.post(url, param);
  }
  // 获取当天刷新稽核日期
  getRefreshTodayAuditDate(param) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_items/date/scan_date';
    return this.httpClient.get(url, {params: param});
  }
  // 获取当天刷新监控日期
  getRefreshTodayIndicatorDate(param) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_items/date/scan_date';
    return this.httpClient.get(url, {params: param});
  }
  // 保存刷新稽核监控记录
  postBoardPulseScanLog(param) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_pulse_scan_log';
    return this.httpClient.post(url, param);
  }
  // 获取历史刷新稽核监控记录
  getBoardPulseScanLog(pulseId, date) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_pulse_scan_log/' + pulseId + '/' + date;
    return this.httpClient.get(url);
  }
  // 刷新稽核
  refreshAuditStatus(param) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule'] : '';
    const url = auditBaseApi + '/v1/audit_items/itemIdList/batchScan';
    // const url = auditBaseApi + '/v1/audit_items/' + itemId + '/scan';
    return this.httpClient.post(url, param);
  }
  // 刷新监控
  refreshMonitorStatus(param) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    // const url = indicatorBaseApi + '/v1/indicator_items/' + itemId + '/scan';
    const url = indicatorBaseApi + '/v1/indicator_items/itemIdList/batchScan';
    return this.httpClient.post(url, param);
  }
  // 稽核-稽核检查项详情，表头列表
  getHeadList(executionId) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_executions/' + executionId + '/columns';
    return this.httpClient.get(url);
  }
  // 稽核-稽核获取总记录数
  getTotalData(executionId, params) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_executions/' + executionId + '/statistics';
    return this.httpClient.post(url, params);
  }
  // 稽核-对比结果数据列表
  getExecutionsList(executionId, params) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_executions/' + executionId + '/results';
    return this.httpClient.post(url, params);
  }
  // 稽核-导出excel
  exportExcel(param, id) {
    const token = localStorage.getItem('id');
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    let url = auditBaseApi + '/v1/audit_executions/' + id + '/export_excel';
    for ( const key in param) {
      if (url.indexOf('?') >= 0) {
        url += '&' + key + '=' + param[key];
      } else {
        url += '?' + key + '=' + param[key];
      }
    }
    if (url.indexOf('?') >= 0) {
      url += '&jtoken=' + token;
    } else {
      url += '?jtoken=' + token;
    }
    window.open(url, '_blank');
  }
  // 稽核-获取稽核项列表
  getAuditList(params) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    // const url = auditBaseApi + '/v1/audit_boards/' + id + '/items';
    const url = auditBaseApi + '/v1/audit_items/itemIdList/execution';
    return this.httpClient.post(url, params);
  }
  // 获取监控项列表
  getSupervisoryList(params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    // const url = indicatorBaseApi + '/v1/indicator_boards/' + id + '/items';
    const url = indicatorBaseApi + '/v1/indicator_items/itemIdList/execution';
    return this.httpClient.post(url, params);
  }
  // 监控-发送预览-发送功能
  sendConfirmOprate(executionId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_item_executions/' + executionId + '/send';
    return this.httpClient.post(url, params);
  }
  // 监控-发送提醒预览功能
  sendReviewOprate(executionId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_item_executions/' + executionId  + '/email/preview';
    return this.httpClient.post(url, params);
  }
  // 监控-编辑列表数据
  editListData(executionId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_item_executions/' + executionId + '/bodyDetail/preview';
    return this.httpClient.post(url, params);
  }
  // 监控-保存模板
  addNoticeTemplate(itemId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_notice_templates/' + itemId;
    return this.httpClient.post(url, params);
  }
  // 监控-外部监控字段映射-列表
  getOutIndicatorItemColumns(outSystemCode, outItemId, itemId) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    let url = indicatorBaseApi + '/v1/out_items/' + outItemId + '/datasource/columns?outSystemCode=' + outSystemCode;
    url = itemId ? url + '&itemId=' + itemId : url;
    return this.httpClient.get(url);
  }
  // 监控-检查项详情，查询条件跟表头
  getIndicatorHeadList(executionId) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_item_executions/' + executionId + '/columns';
    return this.httpClient.get(url);
  }
  // 监控-对比结果数据列表
  getIndicatorExecutionsList(executionId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_item_executions/' + executionId + '/results';
    return this.httpClient.post(url, params);
  }
  // 监控-获取总记录数
  getIndicatorTotalData(executionId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_item_executions/' + executionId + '/statistics';
    return this.httpClient.post(url, params);
  }
  // 监控-导出excel
  exportIndicatorExcel(param, id) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const token = localStorage.getItem('id');
    let url = indicatorBaseApi + '/v1/indicator_item_executions/' + id + '/export_excel';
    for ( const key in param) {
      if (url.indexOf('?') >= 0) {
        url += '&' + key + '=' + param[key];
      } else {
        url += '?' + key + '=' + param[key];
      }
    }
    if (url.indexOf('?') >= 0) {
      url += '&jtoken=' + token;
    } else {
      url += '?jtoken=' + token;
    }
    window.open(url, '_blank');
  }
  // 监控-保存模板
  addIndicatorNoticeTemplate(itemId, params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_notice_templates/' + itemId;
    return this.httpClient.post(url, params);
  }
  // 监控-获取邮件模板
  getEmailTemplateList(itemId) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_items/' + itemId + '/notice_templates';
    return this.httpClient.get(url);
  }
  // 监控-获取分组字段
  getGroupField(dataSourceId) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/data_sources/' + dataSourceId + '/fields';
    return this.httpClient.get(url);
  }
  // 监控-获取用户
  getUserList() {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_boards/users';
    return this.httpClient.get(url);
  }
  // 监控-获取角色
  getRoleList() {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_boards/roles';
    return this.httpClient.get(url);
  }
  // 监控-获取邮件模板内容
  getgetEmailTemplateDetail(templateId) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_notice_templates/' + templateId;
    return this.httpClient.get(url);
  }
  // 报表预览
  reportView(param): Observable<any> {
    const datasourceBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('datasourceModule') && SERVICE_CONFIG.environment['datasourceModule'] ? SERVICE_CONFIG.environment['datasourceModule']  : '';
    const url = datasourceBaseApi + '/v1/excel_report/preview/' + param.reportId;
    const httpOptions: Object = {
      responseType: 'blob',
      params: param
    };
    return this.httpClient.get(url, httpOptions);
  }
  // 获取监控列表
  getIndicatorItems() {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_items';
    return this.httpClient.get(url);
  }
  // 获取稽核列表
  getAuditItems() {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_items';
    return this.httpClient.get(url);
  }
  getTaskList(param) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new';
    return this.httpClient.get(url, {params: param});
  }
  // 面板统计
  boardStatistic(boardId) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_statistic/' + boardId;
    return this.httpClient.get(url);
  }
  // 查询监控规则
  getIndicatorRules(params) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_rules';
    return this.httpClient.get(url, {params: params});
  }
  // 获取系统角色
  getSystemRoles(params) {
    const systemBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('systemModule') && SERVICE_CONFIG.environment['systemModule'] ? SERVICE_CONFIG.environment['systemModule']  : '';
    const url = systemBaseApi + '/v1/roles';
    return this.httpClient.get(url, {params: params});
  }
  // 获取系统参数
  getSysParams() {
    const url = SERVICE_CONFIG.baseApi + '/v2/parameters/query_param_map';
    return this.httpClient.get(url);
  }
  // 查询流程
  queryCategoryProcess() {
    const workflowBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('workflowModule') && SERVICE_CONFIG.environment['workflowModule'] ? SERVICE_CONFIG.environment['workflowModule']  : '';
    const url = workflowBaseApi + '/api/workflow/process_categories/query_category_process';
    return this.httpClient.get(url);
  }
  // 查询流程节点信息
  queryProcessActivityNode(param) {
    const workflowBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('workflowModule') && SERVICE_CONFIG.environment['workflowModule'] ? SERVICE_CONFIG.environment['workflowModule']  : '';
    const url = workflowBaseApi + '/api/workflow/process_instance/query_process_activity_node';
    return this.httpClient.get(url, {params: param});
  }
  // 获取产品列表
  getProdProducts(param) {
    const productBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('productModule') && SERVICE_CONFIG.environment['productModule'] ? SERVICE_CONFIG.environment['productModule']  : '';
    const url = productBaseApi + '/v1/prod_products';
    return this.httpClient.get(url, {params: param});
  }
  // 任务池手工添加任务
  addManualTask(params) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_create_task/manual/task_def';
    return this.httpClient.post(url, params);
  }
  /**
   * 运营中心-任务规则管理相关接口
   *
   */
  // 班次查询
  // getWorkDefs(params) {
  //   // const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
  //   const url = SERVICE_CONFIG.baseApi + '/v1/work_defs';
  //   return this.httpClient.get(url, { params});
  // }
  // 获取运营部岗位
  getProductJob(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/organization_roles';
    return this.httpClient.get(url, {params});
  }
  // 获取组织成员
  getOrgMember(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/organization_roles';
    return this.httpClient.get(url, {params});
  }
  // 获取产品列表人员
  getProductStaff(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/product_operators';
    return this.httpClient.get(url, {params});
  }
  // 新增产品人员
  addProductStaff(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/product_operators';
    return this.httpClient.post(url, params);
  }
  // 产品分工
  getProductOprators(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/product_operators';
    return this.httpClient.get(url, {params});
  }
  // 分配产品
  addProductPresident(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/product_operators/create_by_product';
    return this.httpClient.post(url, params);
  }
  // 删除分配的产品
  deletePeoductPresident(id) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/product_operators/' + id;
    return this.httpClient.delete(url);
  }
  // 任务部门
  getTaskDepartments() {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/operation_org_units/first_level';
    // const url = 'http://gs-ms.91asl.cn:7800/system/v1/operation_orgs';
    return this.httpClient.get(url);
  }
  // 关联稽核指标
  getAuditLists() {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/audit_items';
    // const url = 'http://gs156.91asl.cn:7800/audit/v1/audit_items';
    return this.httpClient.get(url);
  }
  // 关联监控指标
  getIndicatorList() {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/indicator/items';
    return this.httpClient.get(url);
  }
  // 任务管理-新增
  addTask(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new';
    return this.httpClient.post(url, params);
  }
  // 任务管理-详情
  getTaskDetail(id) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new/' + id;
    return this.httpClient.get(url);
  }
  // 任务管理-修改
  editTask(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new';
    return this.httpClient.patch(url, params);
  }
  // 批量编辑任务
  batchEditTask(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new/batch_edit_task_def';
    return this.httpClient.patch(url, params);
  }

  batchDeleteTaskDef(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new/batch_delete_task_def';
    return this.httpClient.post(url, params);
  }
  // 拖拽排序
  drag(params) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new/drag';
    return this.httpClient.patch(url, params);
  }
  // getTaskList(params) {
  //   // const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
  //   const url =  SERVICE_CONFIG.baseApi + '/v1/task_defs_new';
  //   return this.httpClient.get(url, {params: params});
  // }
  deleteTask(id) {
    const operationBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('operationModule') && SERVICE_CONFIG.environment['operationModule'] ? SERVICE_CONFIG.environment['operationModule']  : '';
    const url = operationBaseApi + '/v1/task_defs_new/' + id;
    return this.httpClient.delete(url);
  }
  // 获取报表
  getReportList() {
    const datasourceBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('datasourceModule') && SERVICE_CONFIG.environment['datasourceModule'] ? SERVICE_CONFIG.environment['datasourceModule']  : '';
    const url = datasourceBaseApi + '/v1/excel_report';
    return this.httpClient.get(url);
  }
  /**
   *  产品部统计标签分组
   * @param params boardIds: []
   */
  getLabelGroupStatistics(params) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_statistic/label_group/statistics';
    return this.httpClient.post(url, params);
  }
  getGroupRowsValue(params) {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_statistic/get/group_columns';
    return this.httpClient.get(url, {params: params});
  }
  // 稽核项扫描进度
  auditItemProgress(itemId, executionId) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_items/' + itemId + '/executions/' + executionId + '/progress';
    return this.httpClient.get(url);
  }
  // 获取稽核面板列表
  getAuditBoards(param) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_boards';
    return this.httpClient.get(url, {params: param});
  }
  // 获取监控面板列表
  getIndicatorBoards(param) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_boards';
    return this.httpClient.get(url, {params: param});
  }
  // 获取稽核列表
  getAuditBoardsItem(id, date) {
    const auditBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('auditModule') && SERVICE_CONFIG.environment['auditModule'] ? SERVICE_CONFIG.environment['auditModule']  : '';
    const url = auditBaseApi + '/v1/audit_boards/' + id + '/items/day_detail/' + date;
    return this.httpClient.get(url);
  }
  // 获取监控列表
  getIndicatorBoardsItem(id, date) {
    const indicatorBaseApi = SERVICE_CONFIG.environment.hasOwnProperty('indicatorModule') && SERVICE_CONFIG.environment['indicatorModule'] ? SERVICE_CONFIG.environment['indicatorModule']  : '';
    const url = indicatorBaseApi + '/v1/indicator_boards/' + id + '/items/day_detail/' + date;
    return this.httpClient.get(url);
  }
  // 外部对接接口根据app查询所有业务
  getAllBusiness(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_temp_business_configs/get_all_business';
    return this.httpClient.get(url, {params: param});
  }
  // 查询某个业务下所有类别
  getBusinessCategory(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_business_categories/get_business_category';
    return this.httpClient.get(url, {params: param});
  }
  // 查询字段映射关系
  getBusinessField(param): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_temp_business_aliases/get_business_field';
    return this.httpClient.get(url, {params: param});
  }
  // 创建任务完成情况配置
  postBoardTaskStatus(params): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_comp_task_progress';
    return this.httpClient.post(url, params);
  }
  // 更新任务完成情况配置
  patchBoardTaskStatus(params): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_comp_task_progress/' + params.boardId + '/' + params.value;
    return this.httpClient.patch(url, params);
  }
  // 删除任务完成情况配置
  deleteBoardTaskStatus(id, boardId): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_comp_task_progress/' + boardId + '/' + id;
    return this.httpClient.delete(url);
  }
  // 查询任务完成情况配置
  getBoardTaskStatus(params): Observable<any> {
    const url = SERVICE_CONFIG.baseApi + '/v1/board_comp_task_progress';
    return this.httpClient.get(url, {params: params});
  }
}

export const SERVICE_CONFIG = {
  baseApi: '/task',
  environment: {
    systemModule: '/system',
    taskModule: '/task',
    operationModule: '/operation',
    productModule: '/product',
    auditModule: '/audit',
    indicatorModule: '/indicator',
    datasourceModule: '/datasource',
    workflowModule: '/workflow'
  }
};
